import React from 'react'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import MemberDetail from '../../components/MemberDetail'
import EmptyView from '../../components/basic/EmptyView'
import _ from 'lodash'
import { Box } from 'native-base'

function MemberDetailScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { memberStore, pospalStore, navigation, route } = props
    const { memberId } = route.params
    const [isLoading, setIsLoading] = React.useState(true)
    const [pospalModalVisible, setPospalModalVisible] = React.useState(false)

    React.useEffect(() => {
        const focus = navigation.addListener('focus', async () => {
            try {
                await memberStore.getMember(memberId)
                await pospalStore.listPospal()
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        })
        return focus
    }, [navigation])



    if (isLoading) {
        return <Loading />
    }

    if (!toJS(memberStore.member)) {
        return (
            <EmptyView
                t={t}
            />
        )
    }
    console.log(toJS(memberStore.member))
    console.log(toJS(pospalStore.pospals))
    return (
        <MemberDetail
            t={t}
            member={toJS(memberStore.member)}
            onActionPress={(route) => { return navigation.push(route, { userId: memberId }) }}
            onPospalUserPress={() => setPospalModalVisible(true)}
            pospalModalVisible={pospalModalVisible}
            onPospalModalVisibleClose={() => setPospalModalVisible(false)}
            pospals={toJS(pospalStore.pospals)}
            onPospalPress={(pospalId) => { return navigation.push('PospalUser', { pospalId: pospalId, userId: _id }) }}
        />
    )
}

export default inject('memberStore', 'pospalStore')(observer(MemberDetailScreen))